import { createFileRoute, redirect } from '@tanstack/react-router'
import { MainLayout } from '../components/MainLayout'
import { AnalysisDetailPage } from '../pages/AnalysisDetailPage'
import { useAuthStore } from '../stores/auth-store'

export const Route = createFileRoute('/analysis/$id')({
  component: AnalysisDetail,
  beforeLoad: () => {
    const { isAuthenticated } = useAuthStore.getState()
    if (!isAuthenticated) {
      throw redirect({ to: '/login' })
    }
  },
})

function AnalysisDetail() {
  const { id } = Route.useParams()
  return (
    <MainLayout>
      <AnalysisDetailPage id={id} />
    </MainLayout>
  )
}
